(() => {
  const root = document.querySelector('[data-bundle-cart]');
  if (!root) return;

  try {
    const savedPath = sessionStorage.getItem('bundle-offers:return-url');
    if (savedPath && savedPath.startsWith('/') && !savedPath.startsWith('//')) {
      const destination = new URL(savedPath, window.location.origin);
      if (destination.origin === window.location.origin && /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/collections\//i.test(destination.pathname)) {
        root.querySelectorAll('[data-cart-return]').forEach(link => {
          link.href = destination.pathname + destination.search;
        });
      }
    }
  } catch (_) {}

  const quantities = Array.from(root.querySelectorAll('[data-cart-quantity]'));
  const pendingNotice = root.querySelector('[data-cart-pending]');
  const updateNotice = () => {
    if (pendingNotice) pendingNotice.hidden = quantities.every(input => input.value === input.defaultValue);
  };
  quantities.forEach(input => input.addEventListener('input', updateNotice));
  window.addEventListener('pageshow', updateNotice);
})();
